import { t } from "@lingui/macro";
import type {
  Contractor,
  GetContractorsQuery,
} from "@src/__generated__/graphql";

type TContractor = NonNullable<GetContractorsQuery["contractors"]>["data"][0];

export class ContractorModel {
  id: Contractor["id"];
  registrationNo: Contractor["registration_no"];
  isVatPayer: string;
  iban: Contractor["iban"];
  legalName: Contractor["legal_name"];

  constructor(src: TContractor) {
    this.id = src.id;
    this.registrationNo = src.registration_no;
    this.isVatPayer = src.is_vat_payer ? t`Yes` : t`No`;
    this.iban = src.iban;
    this.legalName = src.legal_name;
  }

  static fromGetContractorsQuery(src: GetContractorsQuery["contractors"]) {
    return (
      src?.data.map((i) => {
        const { id, registration_no, is_vat_payer, iban, legal_name } = i;

        return new ContractorModel({
          id,
          registration_no,
          is_vat_payer,
          iban,
          legal_name,
        });
      }) ?? []
    );
  }
}
